import { useEffect, useState, useCallback } from "react";
import { API_URL } from "../../shared/constant";
import { toast } from "react-toastify";
import axios from "axios";
import Loader from "../../shared/loader";
import Select from "react-select";

const Export = () => {
  const [loading, setLoading] = useState(true);
  const [stockType, setStockType] = useState(null);
  const [stockOptions, setStockOptions] = useState([]);
  const [dealerProducts, setDealerProducts] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [searchTimeout, setSearchTimeout] = useState(null);

  const fetchListData = () => {
    axios.post(API_URL.EXPORT_LIST, {}).then(
      (res) => {
        if (res.data.status === 1) {
          const dataArray = res.data.data.data || [];
          const options = dataArray.map((item) => ({
            value: item.id,
            label:
              item.name ||
              item.title ||
              `${item.first_name} ${item.last_name}` ||
              `Item ${item.id}`,
            data: item,
          }));
          setStockOptions(options);
        }
        setLoading(false);
      },
      (error) => {
        setLoading(false);
        toast.error("Something went wrong..", {
          autoClose: 3000,
        });
      }
    );
  };

  useEffect(() => {
    fetchListData();

    // Cleanup timeout on unmount
    return () => {
      if (searchTimeout) {
        clearTimeout(searchTimeout);
      }
    };
  }, []);

  const fetchDealerProducts = (selectedOption, searchTerm = "") => {
    setLoading(true);
    const exportData = {
      dealer_id: selectedOption.value,
      name: searchTerm,
    };
    axios.post(API_URL.DEALER_PRODUCTS, exportData).then(
      (res) => {
        if (res.data.status === 1) {
          const products = res.data.data.data || [];
          if (searchTerm) {
            setSearchResults(products);
          } else {
            setDealerProducts(products);
          }
        }
        setLoading(false);
      },
      (error) => {
        setLoading(false);
        if (searchTerm) {
          setSearchResults([]);
        } else {
          setDealerProducts([]);
        }
        toast.error("Failed to fetch products", { autoClose: 3000 });
      }
    );
  };

  const handleDropdownChange = (selectedOption) => {
    setStockType(selectedOption);
    setSearchTerm("");
    setSearchResults([]);
    if (selectedOption) {
      fetchDealerProducts(selectedOption);
    }
  };

  const searchProducts = (searchValue) => {
    if (searchValue.length >= 3 && stockType) {
      fetchDealerProducts(stockType, searchValue);
    } else if (searchValue.length < 3) {
      setSearchResults([]);
    }
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    if (searchTimeout) {
      clearTimeout(searchTimeout);
    }
    const timeout = setTimeout(() => {
      searchProducts(value);
    }, 500); // 500ms delay

    setSearchTimeout(timeout);
  };

  return (
    <>
      <div className="row">
        <div className="col-6">
          <h1>
            Stock
            <small className="me-2">
              { dealerProducts.length}
            </small>
          </h1>
        </div>
        <div className="col-6 d-flex align-items-center justify-content-end gap-3">
          <div className="mr-2" style={{ width: 200 }}>
            <Select
              options={stockOptions}
              value={stockType}
              onChange={handleDropdownChange}
              className="react-select-container"
              classNamePrefix="react-select"
              placeholder="Select Dealer"
              noOptionsMessage={() => "No dealers available"}
            />
          </div>
          <div className="col-md-4">
            <input
              type="text"
              className="form-control"
              placeholder="Search by name..."
              value={searchTerm}
              onChange={handleSearchChange}
            />
          </div>
        </div>
      </div>
      <div className="row mt-3">
        <div className="col-sm-12 mt-4">
          <div className="card">
            <div className="card-body p-0">
              {loading && <Loader />}
              {!loading && (
                <div className="table-responsive">
                  <table className="table">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Image</th>
                        <th>Name</th>
                        <th>Category</th>
                        <th>Size</th>
                        <th>Price</th>
                        <th>Stock</th>
                        <th>Stock Remind</th>
                      </tr>
                    </thead>
                    {(searchTerm.length >= 3 ? searchResults : dealerProducts)
                      .length > 0 && (
                      <tbody>
                        {(searchTerm.length >= 3
                          ? searchResults
                          : dealerProducts
                        ).map((product, key) => (
                          <tr key={key}>
                            <td>{key + 1}</td>
                            <td className="table-avatar">
                              <div
                                style={{
                                  backgroundImage: `url(${
                                    product.image ||
                                    "/assets/img/default-product.png"
                                  })`,
                                  height: 50,
                                  width: 50,
                                  backgroundSize: "cover",
                                  backgroundPosition: "center",
                                  borderRadius: "4px",
                                }}
                              ></div>
                            </td>
                            <td>{product.name || "N/A"}</td>
                            <td>{product.category_name || "N/A"}</td>
                            <td>{product.size_name || "N/A"}</td>
                            <td>{product.price || "N/A"}</td>
                            <td>
                              {product.in_stock} -{" "}
                              {product.product?.unit || "N/A"}
                            </td>
                            <td>
                              {product.stock_remind} -{" "}
                              {product.product?.unit || "N/A"}{" "}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    )}
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Export;
